const locale = {
	NOTIFICATIONS: 'Notifications',
	DISMISS_ALL_NOTIFICATIONS: 'Dismiss all',
	MARK_ALL_READ: 'Mark all as read',
	MARK_AS_READ: 'Mark as read',
	CLOSE: 'Close',
	DISMISS_NOTIFICATION: 'Dismiss',
	NO_NOTIFICATIONS: 'There are no notifications for now.',
	TODAY: 'Today',
	DATE_WEEKDAY: "{{ date, eeee }}",
	DATE_MONTH: "{{ date, MMMM }}",
	NOTIFICATIONPANEL_TOOLTIP: 'Notifications',
	LANGUAGESWITCHER_TOOLTIP: 'Change language',
	QUICKPANEL_TOOLTIP: 'Quickinfo',
	HELPPANEL_TOOLTIP: 'Help',
	NOTLOGGEDIN: "Not logged in",
	USERMENU_PROFILE: "My Profile",
	USERMENU_CHANGEPASSWORD: "Change password",
	USERMENU_LOGOUT: "Logout",
	DARKMODE_ACTIVATE: "Darkmode enable",
	DARKMODE_DEACTIVATE: "Darkmode disable",
	SOFTWAREVERSION: "Version",
	USERMENU_RELOAD: "Reload",
	USERMENU_STOP_IMPERSONATION: "Stop impersonation",
	YOUNEEDHELP: "You need support?",
	WEAREHERETOHELP: "We are here to help",
	PHONE: "Phone",
	PHONESUBMESSAGE: "Wir sind telefonisch für Sie erreichbar und freuen uns auf Ihren Anruf",
	OPENINGHOURS: "Monday - Friday | 09:00 - 17:00 o'Clock",
	MESSAGE: "Instantmessage",
	MESSAGESUBMESSAGE: "You can also send us your request directly here and we will take care of it immediately.",
	YOURMESSAGE: "Your request on us",
	SEND: "Send",
	VIEWCHANGELOG: "View Changelog",
	IMPORTANCE: "Importance",
	IMPORTANCE_LOWEST: "Lowest",
	IMPORTANCE_LOWER: "Lower",
	IMPORTANCE_LOW: "Low",
	IMPORTANCE_NORMAL: "Normal",
	IMPORTANCE_HIGH: "High",
	IMPORTANCE_HIGHER: "Higher",
	IMPORTANCE_HIGHEST: "Highest",
	NOTIFICATION_SETTINGS: "Notification Settings",
	BACK: "Back",
	NAVBAR_CLOSE: "Close navigation",
	NAVBAR_OPEN: "Open navigation",
};

export default locale;
